import React from 'react';

import { StyledIcon } from '../StyledIcon';

export const Support = props => (
  <StyledIcon viewBox='0 0 24 24' a11yTitle='Support' {...props}>
    <path fill='none' stroke='#000' strokeWidth='2' d='M12,23 C18.0751322,23 23,18.0751322 23,12 C23,5.92486775 18.0751322,1 12,1 C5.92486775,1 1,5.92486775 1,12 C1,18.0751322 5.92486775,23 12,23 Z M15,23 L15,17 M9,23 L9,17 M15,7 L15,1 M9,7 L9,1 M12,18 C15.3137085,18 18,15.3137085 18,12 C18,8.6862915 15.3137085,6 12,6 C8.6862915,6 6,8.6862915 6,12 C6,15.3137085 8.6862915,18 12,18 Z M1,15 L7,15 M1,9 L7,9 M17,15 L23,15 M17,9 L23,9' transform='rotate(45 12 12)' />
  </StyledIcon>
);
